import React from 'react';

class AccountSettingsView extends React.Component {
  render() {
    return (
      <div>Settings/Account</div>
    )
  }
}

export default AccountSettingsView



// WEBPACK FOOTER //
// ./src/views/settings/account.react.js